import React from 'react';
import deburr from 'lodash/deburr';
import Autosuggest from 'react-autosuggest';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';
import Popper from '@material-ui/core/Popper';
import { makeStyles } from '@material-ui/core/styles';
import './Field.css';

function renderInputComponent(inputProps) {
    const { classes, inputRef = () => { }, ref, ...other } = inputProps;

    return (
        <TextField
            variant="outlined"
            fullWidth
            className={classes.textField}
            InputProps={{
                inputRef: node => {
                    ref(node);
                    inputRef(node);
                },
                classes: {
                    input: classes.input,
                },
                error: !inputProps.errorHidden
            }}
            {...other}
        />
    );
}

function renderSuggestion(suggestion, { query, isHighlighted }) {
    const matches = match(suggestion, query);
    const parts = parse(suggestion, matches);

    return (
        <MenuItem selected={isHighlighted} component="div">
            <div>
                {parts.map(part => (
                    <span key={part.text} style={{ fontWeight: part.highlight ? 500 : 400 }}>
                        {part.text}
                    </span>
                ))}
            </div>
        </MenuItem>
    );
}

function getSuggestions(suggestions, value) {
    const inputValue = deburr(value.trim()).toLowerCase();
    const inputLength = inputValue.length;
    let count = 0;

    if (!suggestions) {
        return [];
    }

    if (inputLength === 0) {
        return suggestions.slice(0, 5);
    }

    return suggestions.filter(suggestion => {
        const keep =
            count < 5 && suggestion.slice(0, inputLength).toLowerCase() === inputValue;

        if (keep) {
            count += 1;
        }

        return keep;
    });
}

function getSuggestionValue(suggestion) {
    return suggestion;
}

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
    },
    container: {
        position: 'relative'
    },
    suggestionsContainerOpen: {
        position: 'absolute',
        zIndex: 1,
        marginTop: theme.spacing(1),
        left: 0,
        right: 0,
    },
    input: {
        color: "#FFF",

    },
    suggestion: {
        display: 'block',
    },
    suggestionsList: {
        margin: 0,
        padding: 0,
        listStyleType: 'none',
    },
    divider: {
        height: theme.spacing(2),
    },
}));

export default function IntegrationAutosuggest(props) {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [state, setState] = React.useState({
        single: '',
        popper: '',
        value: '',
        errorHidden: props.required ? false : true
    });

    const [stateSuggestions, setSuggestions] = React.useState([props.suggestions]);

    const handleSuggestionsFetchRequested = ({ value }) => {
        setSuggestions(getSuggestions(props.data, value));
    };

    const shouldRenderSuggestions = () => true;

    const handleSuggestionsClearRequested = () => {
        setSuggestions([props.suggestions]);
    };

    const handleChange = name => (event, { newValue }) => {
        if (props.data_validate && newValue) {
            const reg = new RegExp(props.data_validate);
            if (reg.test(newValue)) {
                updateValue(name, newValue);
            } else {
                updateValue(name, state.value);
            }
        } else {
            updateValue(name, newValue);
        }
    };

    function updateValue(name, newValue) {
        let errorHidden = ((newValue && newValue.length > 0) || !props.required ? true : false);
        setState({
            ...state,
            value: newValue,
            errorHidden: errorHidden,
            [name]: newValue,
        });
        props.listener(props.name, { value: newValue, error: !errorHidden, root: props.root });
    }

    const autosuggestProps = {
        renderInputComponent,
        suggestions: stateSuggestions,
        onSuggestionsFetchRequested: handleSuggestionsFetchRequested,
        onSuggestionsClearRequested: handleSuggestionsClearRequested,
        getSuggestionValue,
        shouldRenderSuggestions,
        renderSuggestion,
    };

    return (
        <div className="Field">
            <Autosuggest
                {...autosuggestProps}
                inputProps={{
                    classes,
                    errorHidden: state.errorHidden,
                    id: 'react-autosuggest-popper',
                    label: props.title,
                    placeholder: props.placeholder,
                    value: state.popper,
                    onChange: handleChange('popper'),
                    inputRef: node => {
                        setAnchorEl(node);
                    },
                    InputLabelProps: {
                        shrink: true
                    },
                }}
                theme={{
                    suggestionsList: classes.suggestionsList,
                    suggestion: classes.suggestion,
                }}
                renderSuggestionsContainer={options => (
                    <Popper anchorEl={anchorEl} open={Boolean(options.children)}>
                        <Paper
                            square
                            {...options.containerProps}
                            style={{ width: anchorEl ? anchorEl.clientWidth : undefined }}
                        >
                            {options.children}
                        </Paper>
                    </Popper>
                )}
            />
        </div>
    );
}